import React, { useContext, useState, Component } from "react";

import ModalView from "./modal-view";
import RouteView from "./route-view";

export default ({ modalData }) => {
  if (!modalData) return <RouteView />;

  const { to, handleAddSongs, name } = modalData;
  return (
    <ModalView
      title={`Add Songs to ${to}`}
      handleAddSongs={handleAddSongs}
      to={to}
    />
  );
};
